/* Whether a workspace still has to walk the setup wizard.
 *
 * The check is for the key being present and empty, not merely falsy. An
 * organization persisted in the browser before onboarding shipped carries no
 * `onboarded_at` at all, and reading that as "not onboarded" would drop every
 * already-signed-in user into a wizard on their next page load — and, worse,
 * hide those workspaces from the wizard's own "switch workspace" control, which
 * is the one way out of it. Organizations that predate the column were stamped
 * as onboarded by the migration, so a genuinely empty value only ever comes
 * from a workspace created after this shipped.
 */
export const needsOnboarding = (organization) =>
  Boolean(organization) &&
  Object.prototype.hasOwnProperty.call(organization, "onboarded_at") &&
  !organization.onboarded_at;

export default needsOnboarding;
